<style>
#acceptanceRegister .v--modal-box.v--modal {
  min-height: 350px !important;
  min-width: 600px !important;
}
#acceptanceRegister .modal__footer {
  display: none !important;
}
</style>

<template>
  <Modal
    modalName="acceptanceRegister"
    title="Rejestr odbiorów"
    :buttons="[]"
  >
    <AcceptanceTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import AcceptanceTable from "../../table/investments/AcceptanceTable.vue";

export default {
  components: {
    Modal,
    AcceptanceTable
  },
  data: () => ({
  }),
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/management/modals/AcceptanceRegister.vue